// extracted by mini-css-extract-plugin
export default {"labelContainer":"UserThemeSetting-module__labelContainer--ZhOJl","infoIcon":"UserThemeSetting-module__infoIcon--EzAJY","formFooter":"UserThemeSetting-module__formFooter--dj5C9"};